/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import KeyWatcher = alm.browser.KeyWatcher;
	import WindowWatcher = alm.browser.WindowWatcher;
	import WindowWatcherEvent = alm.browser.WindowWatcherEvent;
	import Num = alm.util.Num;
	import DeviceInfo = alm.browser.DeviceInfo;
	import SimpleMovingAverage = alm.math.SimpleMovingAverage;
	import EventDispatcher = alm.event.EventDispatcher;
	import TweenCSS = alm.util.TweenCSS;
	import Easing = alm.math.Easing;
	import Cmd = alm.util.Cmd;
	import KeyWatcherEvent = alm.browser.KeyWatcherEvent;

	export class CameraManager extends EventDispatcher {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		public constructor() {
			super();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public setup(viewportWidth:number, viewportHeight:number, scene:THREE.Scene, canvas:HTMLCanvasElement):void {
			this.scene = scene;

			this.cameraPosition = new THREE.Vector3();
			this.cameraRotation = new THREE.Quaternion();

			this.orbitTarget = new THREE.Vector3();
			this.orbitSpherical = new THREE.Spherical();

			this.cameraTarget = new THREE.PerspectiveCamera();
			this.cameraTarget.up.set(0, 1, 0);
			this.cameraTarget.position.copy(this.cameraPosition);
			//this.cameraTargetLookAt = new THREE.Vector3(0, 0, 0);

			this.camera = new THREE.PerspectiveCamera(30, 1, 1, 10000);
			this.camera.up.copy(this.cameraTarget.up);
			this.camera.position.copy(this.camera.position);
			this.scene.add(this.camera);

			this.isListeningUserEvent = false;

			this.marker = jQuery('#gesture-marker');
			this.isMarkerShown = true;
			this.hideMarker(false);

			WindowWatcher.addEventListener(WindowWatcherEvent.RESIZE, this.windowWatcherResizeHandler);
			WindowWatcher.start();
			this.resize(viewportWidth, viewportHeight);
		}

		public setMap(map:Map):void {
			this.map = map;
		}

		public reset(center:THREE.Vector3):void {
			trace('[CameraManager] reset :', center);
			this.isTracking = true;
			this.isEnding = false;

			// bounds
			const assetLoader = AssetLoader.getInstance();
			const meta = assetLoader.getMeta();
			const dem = assetLoader.getDem();
			const bounds = meta.getBounds();

			const bottomY = Unit.meterToPixel(dem.getMaxElevation(), meta.getZoomLevel());
			const topY = Unit.meterToPixel(dem.getMaxElevation(), meta.getZoomLevel());

			let hMargin = Math.max(bounds.getPixelWidth(), bounds.getPixelHeight());
			let vMargin = topY;

			if (DeviceInfo.getIsDesktop()) {
				hMargin *= 1.5;
				vMargin += 2000;
			} else {
				hMargin *= 3;
				vMargin += 4000;
			}

			this.cameraBoundsTL = new THREE.Vector3(
				bounds.getTopLeft().getPixel().x - hMargin,
				topY + vMargin,
				bounds.getTopLeft().getPixel().y - hMargin,
			);

			this.cameraBoundsBR = new THREE.Vector3(
				bounds.getBottomRight().getPixel().x + hMargin,
				bottomY,
				bounds.getBottomRight().getPixel().y + hMargin,
			);

			// lookAt
			this.setLookAt(center);

			// position
			this.orbitDefaultRadius = Config.mode == Mode.Recording ? 500 : 1000;
			this.orbitDefaultThetaVelocity = 0.002;
			this.orbitDefaultPhi = Num.degToRad(45);

			this.orbitInitRadius = 150; //Config.mode == Mode.Recording ? 150 : 250;
			this.orbitInitThetaVelocity = 0.002;
			this.orbitInitPhi = Num.degToRad(60);

			this.orbitEndingRadius = Config.mode == Mode.Recording ? 1200 : 1500;
			this.orbitEndingThetaVelocity = 0.001;
			this.orbitEndingPhi = Num.degToRad(0);

			this.orbitRadius = this.orbitInitRadius;
			this.orbitThetaVelocity = this.orbitInitThetaVelocity;
			this.orbitTheta = Num.random(Num.PI2);
			this.orbitPhi = this.orbitInitPhi;

			this.orbitSpherical.theta = this.orbitTheta;
			this.orbitSpherical.phi = this.orbitPhi;
			this.orbitSpherical.radius = this.orbitRadius;
			this.orbitSpherical.makeSafe();

			// for mouse
			this.euler = new THREE.Euler();
			this.pitch = 0;
			this.yaw = 0;

			// for touch
			this.isTouchControling = false;

			this.terrainRaycaster = new THREE.Raycaster();
			this.terrainIntersection = null;
			this.terrainIntersectionPoint = null;
			this.terrainIntersectionSpherical = new THREE.Spherical();

			this.plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
			this.planeRaycaster = new THREE.Raycaster();
			this.planePrevIntersection = new THREE.Vector3();
			this.planeLatestIntersection = new THREE.Vector3();
			this.planeDefaultY = (bottomY + topY) * 0.5;
			this.isTouchingToPlane = false;

			this.isTouching1 = false;
			this.touch1StartScreenPosition = new THREE.Vector2(0, 0);
			this.touch1PrevScreenPosition = new THREE.Vector2(0, 0);
			this.touch1LatestScreenPosition = new THREE.Vector2(0, 0);
			this.touch1NormalizedScreenPosition = new THREE.Vector2(0, 0);

			this.isTouching2 = false;
			this.touch2StartScreenPosition = new THREE.Vector2(0, 0);
			this.touch2PrevScreenPosition = new THREE.Vector2(0, 0);
			this.touch2LatestScreenPosition = new THREE.Vector2(0, 0);
			this.touch2NormalizedScreenPosition = new THREE.Vector2(0, 0);

			this.touch2StartAngle = 0;
			this.touch2PrevAngle = 0;
			this.touch2LatestAngle = 0;
			this.touch2AverageAngle = new SimpleMovingAverage(5);

			this.touch2StartDistance = 0;
			this.touch2PrevDistance = 0;
			this.touch2LatestDistance = 0;
			this.touch2AverageDistance = new SimpleMovingAverage(5);

			this.apply(false);

			// marker
			this.markerPosition = new THREE.Vector3();
			this.hideMarker(false);

			this.isMouseDown = false;
			this.isMouseDragging = false;
			this.isShiftKeyDown = false;
		}

		public setInteraction(isEnabled:boolean):void {
			if (this.isListeningUserEvent == isEnabled) return;
			this.isListeningUserEvent = isEnabled;
			trace('[CameraManager] start listening user events : touch enabled =', DeviceInfo.getIsTouchEnabled());

			if (this.isListeningUserEvent) {
				if (DeviceInfo.getIsTouchEnabled()) {
					document.addEventListener('touchstart', this.touchStartHandler, { capture: false, passive: false });
					document.addEventListener('touchmove', this.touchMoveHandler, { capture: false, passive: false });
					document.addEventListener('touchend', this.touchEndHandler, { capture: false, passive: false });
				} else {
					document.addEventListener('mousedown', this.mouseDownHandler, { capture: false, passive: false });
					document.addEventListener('mousemove', this.mouseMoveHandler, { capture: false, passive: false });
					document.addEventListener('mouseup', this.mouseUpHandler, { capture: false, passive: false });
					document.addEventListener('wheel', this.mouseWheelHandler);
					//KeyWatcher.addEventListener(KeyWatcherEvent.KEY_DOWN, this.keyDownHandler);
					//KeyWatcher.addEventListener(KeyWatcherEvent.KEY_UP, this.keyUpHandler);
					//KeyWatcher.setIsContinuousPressEnabled(true);
					//KeyWatcher.start();
				}
			} else {
				if (DeviceInfo.getIsTouchEnabled()) {
					document.removeEventListener('touchstart', this.touchStartHandler);
					document.removeEventListener('touchmove', this.touchMoveHandler);
					document.removeEventListener('touchend', this.touchEndHandler);
				} else {
					document.removeEventListener('mousedown', this.mouseDownHandler);
					document.removeEventListener('mousemove', this.mouseMoveHandler);
					document.removeEventListener('mouseup', this.mouseUpHandler);
					document.removeEventListener('wheel', this.mouseWheelHandler);
					//KeyWatcher.removeEventListener(KeyWatcherEvent.KEY_DOWN, this.keyDownHandler);
					//KeyWatcher.removeEventListener(KeyWatcherEvent.KEY_UP, this.keyUpHandler);
					//KeyWatcher.stop();
				}
			}
		}

		public update(useTransition:boolean = true):void {
			// update orbit when tracking
			if (this.isTracking) {
				this.orbitTheta += this.orbitThetaVelocity;
				this.orbitSpherical.theta = this.orbitTheta;
				this.orbitSpherical.phi = this.orbitPhi;
				this.orbitSpherical.radius = this.orbitRadius;
				this.orbitSpherical.makeSafe();
			}

			this.apply(useTransition);
		}

		private apply(useTransition:boolean = true):void {
			// update target attitude when tracking
			if (this.isTracking) {
				//this.cameraTargetLookAt.copy(this.orbitTarget);
				this.cameraTarget.position.setFromSpherical(this.orbitSpherical);
				this.cameraTarget.position.add(this.orbitTarget);
				this.cameraTarget.lookAt(this.orbitTarget);
				this.cameraTarget.updateMatrix();
			}

			// avoid terrain
			{
				const cameraPosition = this.cameraTarget.position;
				const terrainY = this.map.getMapY(cameraPosition.x, cameraPosition.z);
				if (terrainY >= 0 && terrainY + 5 > cameraPosition.y) {
					this.cameraTarget.position.y = terrainY + 5;
					this.cameraTarget.updateMatrix();
				}
			}

			// bounds
			{
				let isNeedUpdate = false;
				const cameraPosition = this.cameraTarget.position;

				if (cameraPosition.x < this.cameraBoundsTL.x) {
					cameraPosition.x = this.cameraBoundsTL.x;
					isNeedUpdate = true;
				} else if (cameraPosition.x > this.cameraBoundsBR.x) {
					cameraPosition.x = this.cameraBoundsBR.x;
					isNeedUpdate = true;
				}

				if (cameraPosition.y > this.cameraBoundsTL.y) {
					cameraPosition.y = this.cameraBoundsTL.y;
					isNeedUpdate = true;
				} else if (cameraPosition.y < this.cameraBoundsBR.y) {
					cameraPosition.y = this.cameraBoundsBR.y;
					isNeedUpdate = true;
				}

				if (cameraPosition.z < this.cameraBoundsTL.z) {
					cameraPosition.z = this.cameraBoundsTL.z;
					isNeedUpdate = true;
				} else if (cameraPosition.z > this.cameraBoundsBR.z) {
					cameraPosition.z = this.cameraBoundsBR.z;
					isNeedUpdate = true;
				}

				if (isNeedUpdate) {
					this.cameraTarget.position.copy(cameraPosition);
				}
			}

			// update current attitude
			const positionEasing = useTransition ? this.isTouchControling ? 0.1 : 0.05 : 1;
			this.cameraPosition.lerp(this.cameraTarget.position, positionEasing);

			const rotationEasing = useTransition ? this.isTouchControling ? 0.1 : 0.05 : 1;
			this.cameraRotation.slerp(this.cameraTarget.quaternion, rotationEasing);

			// apply attitude
			this.camera.position.copy(this.cameraPosition);
			this.camera.setRotationFromQuaternion(this.cameraRotation);
			this.camera.updateMatrix();

			// marker
			if (this.isOrbitMode) {
				this.project(this.terrainIntersectionPoint, this.markerPosition);
				this.marker.css({
					left: this.markerPosition.x,
					top: this.markerPosition.y,
				});
			}
		}

		public startOpening():void {
			this.isEnding = false;

			this.sequenceTween = Cmd.stop(this.sequenceTween);
			this.sequenceTween = new cmd.Serial(
				new cmd.Tween(this, { orbitRadius: this.orbitDefaultRadius, orbitThetaVelocity: this.orbitDefaultThetaVelocity, orbitPhi: this.orbitDefaultPhi }, null, 4000, Easing.easeInOutQuart)
			);
			this.sequenceTween.execute();
		}

		public startEnding(orbitPosition:THREE.Vector3):void {
			this.isEnding = true;

			const orbitTargetX0 = this.orbitTarget.x;
			const orbitTargetY0 = this.orbitTarget.y;
			const orbitTargetZ0 = this.orbitTarget.z;

			const orbitTargetX1 = orbitPosition.x;
			const orbitTargetY1 = orbitPosition.y;
			const orbitTargetZ1 = orbitPosition.z;

			this.sequenceTween = Cmd.stop(this.sequenceTween);
			this.sequenceTween = new cmd.Serial(
				new cmd.Tween(this, { orbitRadius: this.orbitEndingRadius, orbitThetaVelocity: this.orbitEndingThetaVelocity, orbitPhi: this.orbitEndingPhi }, null, 4000, Easing.easeInOutQuart, null, (ratio:number):void => {
					const invRatio = 1 - ratio;
					this.orbitTarget.set(
							invRatio * orbitTargetX0 + ratio * orbitTargetX1,
							invRatio * orbitTargetY0 + ratio * orbitTargetY1,
							invRatio * orbitTargetZ0 + ratio * orbitTargetZ1
					);
				})
			);
			this.sequenceTween.execute();
		}

		private updateEuler():void {
			this.euler.set(this.pitch, this.yaw, 0, 'ZYX');
			this.cameraTarget.setRotationFromEuler(this.euler);
			this.cameraTarget.updateMatrix();
		}

		public resize(viewportWidth:number, viewportHeight:number):void {
			trace('[CameraManager] resize :', viewportWidth, viewportHeight);

			this.viewportWidth = viewportWidth;
			this.viewportHeight = viewportHeight;

			this.projectOffsetX = this.viewportWidth * 0.5;
			this.projectOffsetY = this.viewportHeight * 0.5;

			this.camera.aspect = this.viewportWidth / this.viewportHeight;
			this.camera.updateProjectionMatrix();
		}

		public project(point:THREE.Vector3, result:THREE.Vector3 = null):void {
			if (result) {
				result.copy(point);
			} else {
				result = point;
			}
			result.project(this.camera);
			result.x = (result.x + 1) * this.projectOffsetX;
			result.y = (1 - result.y) * this.projectOffsetY;
		}

		public setLookAt(position:THREE.Vector3):void {
			//this.cameraTargetLookAt.copy(position);
			this.orbitTarget.copy(position);
		}

		public getCamera():THREE.PerspectiveCamera {
			return this.camera;
		}

		public toggleTracking(isTracking:boolean):void {
			if (this.isTracking == isTracking) return;
			this.isTracking = isTracking;

			if (this.isTracking) {
				// euler to orbit
			} else {
				// orbit to euler
				const euler = this.cameraTarget.rotation;
				this.pitch = euler.x;
				this.yaw = euler.y;
			}

			this.dispatchEvent(new CameraTrackingEvent(CameraTrackingEvent.CHANGE, this, this.isTracking));
		}

		public getIsTracking():boolean {
			return this.isTracking;
		}

		public getIsEnding():boolean {
			return this.isEnding;
		}





		private windowWatcherResizeHandler = (event:WindowWatcherEvent):void => {
			this.resize(WindowWatcher.getWindowWidth(), WindowWatcher.getWindowHeight());
		};





		private touchStartHandler = (event:TouchEvent):void => {
			event.preventDefault();

			const touches = event.touches;
			switch (touches.length) {
				case 1:
					// start truck
					this.isTouching1 = true;
					this.isTouching2 = false;

					this.getTouchScreenPosition(touches[0], this.touch1StartScreenPosition);
					this.touch1PrevScreenPosition.copy(this.touch1StartScreenPosition);
					this.touch1LatestScreenPosition.copy(this.touch1StartScreenPosition);
					this.getNormalizedScreenPosition(this.touch1LatestScreenPosition.x, this.touch1LatestScreenPosition.y, this.touch1NormalizedScreenPosition);

					this.terrainRaycaster.setFromCamera(this.touch1NormalizedScreenPosition, this.camera);
					this.terrainIntersection = this.map.getIntersection(this.terrainRaycaster);
					//trace('[CameraManager] terrain intersection :', this.terrainIntersection);

					if (this.terrainIntersection) {
						this.terrainIntersectionPoint = this.terrainIntersection.point;
						this.plane.constant = this.terrainIntersectionPoint.y;
						this.isTouchingToPlane = false;
					} else {
						this.terrainIntersectionPoint = null;
						this.plane.constant = this.planeDefaultY;
						this.isTouchingToPlane = true;
					}

					this.planeRaycaster.setFromCamera(this.touch1NormalizedScreenPosition, this.camera);
					this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);
					this.planePrevIntersection.copy(this.planeLatestIntersection);
					break;

				case 2:
					this.isTouching1 = false;
					this.isTouching2 = true;

					this.getTouchCenterScreenPosition(touches, this.touch2StartScreenPosition);
					this.touch2PrevScreenPosition.copy(this.touch2StartScreenPosition);
					this.touch2LatestScreenPosition.copy(this.touch2StartScreenPosition);
					this.getNormalizedScreenPosition(this.touch2LatestScreenPosition.x, this.touch2LatestScreenPosition.y, this.touch2NormalizedScreenPosition);

					this.touch2LatestAngle = this.touch2PrevAngle = this.touch2StartAngle = this.getTouchRotation(touches);
					//trace('[CameraManager] touch 2 angle :', this.touch2LatestAngle);

					this.touch2LatestDistance = this.touch2PrevDistance = this.touch2StartDistance = this.getTouchDistance(touches);
					//trace('[CameraManager] touch 2 distance :', this.touch2LatestDistance);

					this.terrainRaycaster.setFromCamera(this.touch2NormalizedScreenPosition, this.camera);
					this.terrainIntersection = this.map.getIntersection(this.terrainRaycaster);
					//trace('[CameraManager] terrain intersection :', this.terrainIntersection);
					if (this.terrainIntersection != null) {
						this.terrainIntersectionPoint = this.terrainIntersection.point;
						this.terrainIntersectionSpherical.setFromVector3(new THREE.Vector3().subVectors(this.camera.position, this.terrainIntersectionPoint));

						this.isTouchingToPlane = false;
						//this.plane.constant = this.terrainIntersectionPoint.y;
						//this.planeRaycaster.setFromCamera(this.touch2NormalizedScreenPosition, this.camera);
						//this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);
						//this.planePrevIntersection.copy(this.planeLatestIntersection);
					} else {
						//this.terrainIntersectionPoint = null;
						//this.isTouching2 = false;

						this.isTouchingToPlane = true;
						this.plane.constant = this.planeDefaultY;
						this.planeRaycaster.setFromCamera(this.touch2NormalizedScreenPosition, this.camera);
						this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);
						this.planePrevIntersection.copy(this.planeLatestIntersection);
						this.terrainIntersectionPoint = this.planeLatestIntersection;
						//trace('[CameraManager] plane intersection :', this.terrainIntersectionPoint);
					}

					{
						this.cameraTarget.position.setFromSpherical(this.terrainIntersectionSpherical);
						this.cameraTarget.position.add(this.terrainIntersectionPoint);
						this.cameraTarget.lookAt(this.terrainIntersectionPoint);
						this.cameraTarget.updateMatrix();
					}

					break;

				default:
					// stop all gesture
					this.isTouching1 = false;
					this.isTouching2 = false;
					break;
			}

			this.isTouchControling = this.isTouching1 || this.isTouching2;
			if (this.isTouchControling) {
				this.toggleTracking(false);
			}
		};

		private touchMoveHandler = (event:TouchEvent):void => {
			event.preventDefault();

			const touches = event.touches;

			if (this.isTouching1) {
				this.getTouchScreenPosition(touches[0], this.touch1LatestScreenPosition);
				this.getNormalizedScreenPosition(this.touch1LatestScreenPosition.x, this.touch1LatestScreenPosition.y, this.touch1NormalizedScreenPosition);

				this.planeRaycaster.setFromCamera(this.touch1NormalizedScreenPosition, this.camera);
				this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);

				const deltaX = this.planeLatestIntersection.x - this.planePrevIntersection.x;
				const deltaZ = this.planeLatestIntersection.z - this.planePrevIntersection.z;

				const scale = 1.2;
				let velocityX = -deltaX * scale;
				let velocityY = -deltaZ * scale;

				velocityX = Num.clampAbs(velocityX, 0, 100);
				velocityY = Num.clampAbs(velocityY, 0, 100);

				this.cameraTarget.position.x += velocityX;
				this.cameraTarget.position.z += velocityY;

				this.planePrevIntersection.copy(this.planeLatestIntersection);

				// save
				this.touch1PrevScreenPosition.copy(this.touch1LatestScreenPosition);
			}

			if (this.isTouching2) {
				this.getTouchCenterScreenPosition(touches, this.touch2LatestScreenPosition);
				this.getNormalizedScreenPosition(this.touch2LatestScreenPosition.x, this.touch2LatestScreenPosition.y, this.touch2NormalizedScreenPosition);

				const sphericalCenter = this.terrainIntersectionPoint;
				const spherical:THREE.Spherical = this.terrainIntersectionSpherical;

				// translation
				/*
				{
					this.planeRaycaster.setFromCamera(this.touch2NormalizedScreenPosition, this.camera);
					this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);

					const deltaX = this.planeLatestIntersection.x - this.planePrevIntersection.x;
					sphericalCenter.x += -deltaX * 1.2;

					this.planePrevIntersection.copy(this.planeLatestIntersection);
				}
				*/

				this.touch2LatestAngle = this.getTouchRotation(touches);
				//trace('[CameraManager] touch 2 angle :', this.touch2LatestAngle);
				const deltaAngle = Num.turn(this.touch2PrevAngle, this.touch2LatestAngle, true);
				spherical.theta -= deltaAngle;

				this.touch2LatestDistance = this.getTouchDistance(touches);
				//trace('[CameraManager] touch 2 distance :', this.touch2LatestDistance);
				const deltaDistance = this.touch2LatestDistance - this.touch2PrevDistance;
				spherical.radius -= deltaDistance * 10;
				spherical.radius = Math.max(1, spherical.radius);

				if (!this.isTouchingToPlane) {
					const deltaY = this.touch2LatestScreenPosition.y - this.touch2PrevScreenPosition.y;
					//trace('[CameraManager] touch 2 delta y :', this.touch2LatestDistance);
					spherical.phi -= deltaY * 0.02;
					spherical.phi = Num.clamp(spherical.phi, 0.01, Math.PI * 0.49);
				}

				//trace('[CameraManager] touch 2 radius :', spherical.radius);
				//trace('[CameraManager] touch 2 theta :', spherical.theta);
				//trace('[CameraManager] touch 2 phi :', spherical.phi);

				this.cameraTarget.position.setFromSpherical(spherical);
				this.cameraTarget.position.add(sphericalCenter);
				this.cameraTarget.lookAt(sphericalCenter);
				//this.cameraTarget.lookAt(this.cameraTargetLookAt);
				this.cameraTarget.updateMatrix();

				// save
				this.touch2PrevScreenPosition.copy(this.touch2LatestScreenPosition);
				this.touch2PrevAngle = this.touch2LatestAngle;
				this.touch2PrevDistance = this.touch2LatestDistance;
			}
		};

		private touchEndHandler = (event:TouchEvent):void => {
			event.preventDefault();

			const touches = event.touches;
			switch (touches.length) {
				case 1:
					// stop tilt, rotate, dolly
					this.isTouching2 = false;
					break;

				case 2:
					// stop truck
					this.isTouching1 = false;
					break;

				default:
					// stop all gesture
					this.isTouching1 = false;
					this.isTouching2 = false;
					break;
			}

			this.isTouchControling = this.isTouching1 || this.isTouching2;
		};

		private getNormalizedScreenPosition(screenX:number, screenY:number, result:THREE.Vector2 = null):THREE.Vector2 {
			if (result == null) result = new THREE.Vector2();
			result.set(screenX / this.viewportWidth * 2 - 1, 1 - screenY / this.viewportHeight * 2);
			return result;
		}

		private getTouchScreenPosition(touch:Touch, result:THREE.Vector2 = null):THREE.Vector2 {
			if (result == null) result = new THREE.Vector2();
			result.set(touch.pageX, touch.pageY);
			return result;
		}

		private getTouchCenterScreenPosition(touches:TouchList, result:THREE.Vector2 = null):THREE.Vector2 {
			if (result == null) result = new THREE.Vector2();
			const a = touches[0];
			const b = touches[1];
			result.set(
				(a.pageX + b.pageX) * 0.5,
				(a.pageY + b.pageY) * 0.5,
			);
			return result;
		}

		private getTouchDistance(touches:TouchList):number {
			const a = touches[0];
			const b = touches[1];
			const dx = b.pageX - a.pageX;
			const dy = b.pageY - a.pageY;
			return Math.sqrt(dx * dx + dy * dy);
		}

		private getTouchRotation(touches:TouchList):number {
			const a = touches[0];
			const b = touches[1];
			return Math.atan2(b.pageX - a.pageX, b.pageY - a.pageY);
		}





		private mouseDownHandler = (event:MouseEvent):void => {
			if (event.button != 0) return;
			trace('[CameraManager] mouse down');
			event.preventDefault();

			const mouseX = event.clientX;
			const mouseY = event.clientY;

			this.isMouseDown = true;
			this.isMouseDragging = false;
			this.mouseDownX = mouseX;
			this.mouseDownY = mouseY;

			if (this.isWaitingSecondMouseDown) {
				this.isWaitingSecondMouseDown = false;
				const distance = Num.dist(mouseX, mouseY, this.mouseUpX, this.mouseUpY);
				const delay = Date.now() - this.mouseUpTime;
				if (distance < 5 && delay < 500) {
					this.isMouseDragging = true;
					this.dragStartX = mouseX;
					this.dragStartY = mouseY;
					this.startOrbit();
				}
			}
		};

		private mouseMoveHandler = (event:MouseEvent):void => {
			event.preventDefault();

			if (this.isMouseDown) {
				const mouseX = event.clientX;
				const mouseY = event.clientY;

				if (!this.isMouseDragging) {
					const distance = Num.dist(mouseX, mouseY, this.mouseDownX, this.mouseDownY);
					if (distance > 5) {
						this.isMouseDragging = true;
						this.dragStartX = mouseX;
						this.dragStartY = mouseY;

						if (this.isShiftKeyDown) {
							this.startOrbit();
						} else {
							this.startTruck();
						}
					}
				}

				if (this.isTruckMode) {
					this.touch1LatestScreenPosition.set(mouseX, mouseY); // PC
					this.getNormalizedScreenPosition(this.touch1LatestScreenPosition.x, this.touch1LatestScreenPosition.y, this.touch1NormalizedScreenPosition);

					this.planeRaycaster.setFromCamera(this.touch1NormalizedScreenPosition, this.camera);
					this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);

					const deltaX = this.planeLatestIntersection.x - this.planePrevIntersection.x;
					const deltaZ = this.planeLatestIntersection.z - this.planePrevIntersection.z;

					const scale = 2.5; // PC
					let velocityX = -deltaX * scale;
					let velocityY = -deltaZ * scale;

					velocityX = Num.clampAbs(velocityX, 0, 100);
					velocityY = Num.clampAbs(velocityY, 0, 100);

					this.cameraTarget.position.x += velocityX;
					this.cameraTarget.position.z += velocityY;

					this.planePrevIntersection.copy(this.planeLatestIntersection);

					// save
					this.touch1PrevScreenPosition.copy(this.touch1LatestScreenPosition);
				}

				if (this.isOrbitMode) {
					this.touch2LatestScreenPosition.set(mouseX, mouseY);
					this.getNormalizedScreenPosition(this.touch2LatestScreenPosition.x, this.touch2LatestScreenPosition.y, this.touch2NormalizedScreenPosition);

					const sphericalCenter = this.terrainIntersectionPoint;
					const spherical:THREE.Spherical = this.terrainIntersectionSpherical;

					this.touch2LatestAngle = (this.touch2LatestScreenPosition.x - this.dragStartX) / (WindowWatcher.getWindowWidth() * 0.5) * Math.PI; // PC
					//trace('[CameraManager] touch 2 angle :', this.touch2LatestAngle);
					const deltaAngle = Num.turn(this.touch2PrevAngle, this.touch2LatestAngle, true);
					spherical.theta -= deltaAngle;

					// PC
					/*
					this.touch2LatestDistance = this.getTouchDistance(touches);
					//trace('[CameraManager] touch 2 distance :', this.touch2LatestDistance);
					const deltaDistance = this.touch2LatestDistance - this.touch2PrevDistance;
					spherical.radius -= deltaDistance * 10;
					spherical.radius = Math.max(1, spherical.radius);
					*/

					if (!this.isTouchingToPlane) {
						const deltaY = this.touch2LatestScreenPosition.y - this.touch2PrevScreenPosition.y;
						//trace('[CameraManager] touch 2 delta y :', this.touch2LatestDistance);
						spherical.phi -= deltaY * 0.005; // PC
						spherical.phi = Num.clamp(spherical.phi, 0.01, Math.PI * 0.49);
					}

					//trace('[CameraManager] touch 2 radius :', spherical.radius);
					//trace('[CameraManager] touch 2 theta :', spherical.theta);
					//trace('[CameraManager] touch 2 phi :', spherical.phi);

					///*
					this.cameraTarget.position.setFromSpherical(spherical);
					this.cameraTarget.position.add(sphericalCenter);
					this.cameraTarget.lookAt(sphericalCenter);
					//this.cameraTarget.applyQuaternion(this.orbitLookAt);
					this.cameraTarget.updateMatrix();
					//*/

					/*
					this.cameraTarget.applyQuaternion(this.orbitOffsetLookAt);
					//this.cameraTarget.quaternion.multiply(this.orbitOffsetLookAt);
					this.cameraTarget.updateMatrix();
					*/

					/*
					{
						const o = new THREE.Object3D();
						o.position.setFromSpherical(spherical);
						o.position.add(sphericalCenter);
						o.lookAt(sphericalCenter);
						o.quaternion.multiply(this.orbitOffsetLookAt);
						o.updateMatrix();

						this.cameraTarget.setRotationFromQuaternion(o.quaternion);
						this.cameraTarget.updateMatrix();
					}
					*/

					// save
					this.touch2PrevScreenPosition.copy(this.touch2LatestScreenPosition);
					this.touch2PrevAngle = this.touch2LatestAngle;
					this.touch2PrevDistance = this.touch2LatestDistance;
				}
			}
		};

		private mouseUpHandler = (event:MouseEvent):void => {
			if (event.button != 0) return;
			trace('[CameraManager] mouse up');
			event.preventDefault();

			this.mouseUpX = event.clientX;
			this.mouseUpY = event.clientY;
			this.mouseUpTime = Date.now();
			if (!this.isMouseDragging) {
				this.isWaitingSecondMouseDown = true;
			}

			this.stopTruck();
			this.stopOrbit();
		};

		private mouseWheelHandler = (event:WheelEvent):void => {
			trace('[CameraManager] mouse wheel : delta =', event.deltaY);
			event.preventDefault();

			const distance = event.deltaY;

			const forward = new THREE.Vector4(0, 0, 1, 0);
			forward.applyMatrix4(this.cameraTarget.matrix);
			forward.normalize();
			forward.multiplyScalar(distance);

			const diff = new THREE.Vector3(forward.x, forward.y, forward.z);
			this.cameraTarget.position.add(diff);
			//this.cameraTargetLookAt.add(diff);
		};

		private keyDownHandler = (event:KeyWatcherEvent):void => {
			this.isShiftKeyDown = event.shiftKey;
		};

		private keyUpHandler = (event:KeyWatcherEvent):void => {
			this.isShiftKeyDown = event.shiftKey;
		};

		private startOrbit():void {
			if (this.isOrbitMode) return;
			this.isOrbitMode = true;
			trace('[CameraManager] startOrbit');

			this.touch2StartScreenPosition.set(this.dragStartX, this.dragStartY); // PC
			this.touch2PrevScreenPosition.copy(this.touch2StartScreenPosition);
			this.touch2LatestScreenPosition.copy(this.touch2StartScreenPosition);
			this.getNormalizedScreenPosition(this.touch2LatestScreenPosition.x, this.touch2LatestScreenPosition.y, this.touch2NormalizedScreenPosition);

			this.touch2LatestAngle = this.touch2PrevAngle = this.touch2StartAngle = 0; // PC
			//trace('[CameraManager] touch 2 angle :', this.touch2LatestAngle);

			this.touch2LatestDistance = this.touch2PrevDistance = this.touch2StartDistance = 0; // PC
			//trace('[CameraManager] touch 2 distance :', this.touch2LatestDistance);

			this.terrainRaycaster.setFromCamera(this.touch2NormalizedScreenPosition, this.camera);
			this.terrainIntersection = this.map.getIntersection(this.terrainRaycaster);
			//trace('[CameraManager] terrain intersection :', this.terrainIntersection);
			if (this.terrainIntersection != null) {
				this.terrainIntersectionPoint = this.terrainIntersection.point;
				this.terrainIntersectionSpherical.setFromVector3(new THREE.Vector3().subVectors(this.camera.position, this.terrainIntersectionPoint));

				this.isTouchingToPlane = false;
				//this.plane.constant = this.terrainIntersectionPoint.y;
				//this.planeRaycaster.setFromCamera(this.touch2NormalizedScreenPosition, this.camera);
				//this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);
				//this.planePrevIntersection.copy(this.planeLatestIntersection);
			} else {
				//this.terrainIntersectionPoint = null;
				//this.isTouching2 = false;

				/*
				// 地形以外もつかめる
				this.isTouchingToPlane = true;
				this.plane.constant = this.planeDefaultY;
				this.planeRaycaster.setFromCamera(this.touch2NormalizedScreenPosition, this.camera);
				this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);
				this.planePrevIntersection.copy(this.planeLatestIntersection);
				this.terrainIntersectionPoint = this.planeLatestIntersection;
				*/

				//trace('[CameraManager] plane intersection :', this.terrainIntersectionPoint);
			}

			/*
			{
				const currentQuaternion = this.camera.quaternion.clone();

				const lookingCenter = new THREE.Object3D();
				lookingCenter.up.set(0, 1, 0);
				lookingCenter.position.copy(this.camera.position);
				lookingCenter.lookAt(this.terrainIntersectionPoint);
				lookingCenter.updateMatrix();

				this.orbitOffsetLookAt = new THREE.Quaternion();
				this.orbitOffsetLookAt = this.orbitOffsetLookAt.multiplyQuaternions(currentQuaternion, lookingCenter.quaternion.inverse());

				//this.orbitOffsetLookAt = lookingCenter.quaternion.inverse().multiply(currentQuaternion);
			}
			*/

			// つかめなかったら終了
			if (this.terrainIntersection == null) {
				this.stopOrbit();
				return;
			}

			{
				this.cameraTarget.position.setFromSpherical(this.terrainIntersectionSpherical);
				this.cameraTarget.position.add(this.terrainIntersectionPoint);
				this.cameraTarget.lookAt(this.terrainIntersectionPoint);
				this.cameraTarget.updateMatrix();
			}

			this.showMarker();

			this.isTouchControling = true;
			this.toggleTracking(false);
		}

		private stopOrbit():void {
			if (!this.isOrbitMode) return;
			this.isOrbitMode = false;
			trace('[CameraManager] stopOrbit');

			this.hideMarker();

			this.isTouchControling = this.isOrbitMode || this.isOrbitMode;
		}

		private startTruck():void {
			if (this.isTruckMode) return;
			this.isTruckMode = true;
			trace('[CameraManager] startTruck');

			this.touch1StartScreenPosition.set(this.dragStartX, this.dragStartY); // PC
			this.touch1PrevScreenPosition.copy(this.touch1StartScreenPosition);
			this.touch1LatestScreenPosition.copy(this.touch1StartScreenPosition);
			this.getNormalizedScreenPosition(this.touch1LatestScreenPosition.x, this.touch1LatestScreenPosition.y, this.touch1NormalizedScreenPosition);

			this.terrainRaycaster.setFromCamera(this.touch1NormalizedScreenPosition, this.camera);
			this.terrainIntersection = this.map.getIntersection(this.terrainRaycaster);
			//trace('[CameraManager] terrain intersection :', this.terrainIntersection);

			if (this.terrainIntersection) {
				this.terrainIntersectionPoint = this.terrainIntersection.point;
				this.plane.constant = this.terrainIntersectionPoint.y;
				this.isTouchingToPlane = false;
			} else {
				this.terrainIntersectionPoint = null;
				this.plane.constant = this.planeDefaultY;
				this.isTouchingToPlane = true;
			}

			this.planeRaycaster.setFromCamera(this.touch1NormalizedScreenPosition, this.camera);
			this.planeRaycaster.ray.intersectPlane(this.plane, this.planeLatestIntersection);
			this.planePrevIntersection.copy(this.planeLatestIntersection);

			this.isTouchControling = true;
			this.toggleTracking(false);
		}

		private stopTruck():void {
			if (!this.isTruckMode) return;
			this.isTruckMode = false;
			trace('[CameraManager] stopTruck');

			this.isTouchControling = this.isOrbitMode || this.isOrbitMode;
		}





		private showMarker(useTransition:boolean = true):void {
			if (this.isMarkerShown) return;
			this.isMarkerShown = true;

			alm.util.Cmd.stop(this.markerTween);
			this.markerTween = TweenCSS.fadeIn(this.marker, useTransition ? 200 : 0, Easing.easeOutQuart, 'block', false, false);
			this.markerTween.execute();
		}

		private hideMarker(useTransition:boolean = true):void {
			if (!this.isMarkerShown) return;
			this.isMarkerShown = false;

			alm.util.Cmd.stop(this.markerTween);
			this.markerTween = TweenCSS.fadeOut(this.marker, useTransition ? 200 : 0, Easing.easeOutQuart, true, false, false);
			this.markerTween.execute();
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isListeningUserEvent:boolean;

		private scene:THREE.Scene;
		private map:Map;

		private camera:THREE.PerspectiveCamera;
		private cameraPosition:THREE.Vector3;
		private cameraRotation:THREE.Quaternion;
		//private cameraTargetLookAt:THREE.Vector3;
		private cameraTarget:THREE.PerspectiveCamera;

		private cameraBoundsTL:THREE.Vector3;
		private cameraBoundsBR:THREE.Vector3;

		private viewportWidth:number;
		private viewportHeight:number;

		private projectOffsetX:number;
		private projectOffsetY:number;

		private isTracking:boolean;

		// for tracking
		private orbitTarget:THREE.Vector3;
		private orbitSpherical:THREE.Spherical;
		private orbitRadius:number;
		private orbitThetaVelocity:number;
		private orbitTheta:number;
		private orbitPhi:number;

		private orbitDefaultRadius:number;
		private orbitDefaultThetaVelocity:number;
		private orbitDefaultPhi:number;

		private orbitInitRadius:number;
		private orbitInitThetaVelocity:number;
		private orbitInitPhi:number;

		private orbitEndingRadius:number;
		private orbitEndingThetaVelocity:number;
		private orbitEndingPhi:number;

		// for mouse
		private pitch:number;
		private yaw:number;
		private euler:THREE.Euler;

		// for touch
		private isTouchControling:boolean;

		private terrainRaycaster:THREE.Raycaster;
		private terrainIntersection:THREE.Intersection;
		private terrainIntersectionPoint:THREE.Vector3;
		private terrainIntersectionSpherical:THREE.Spherical;

		private plane:THREE.Plane;
		private planeRaycaster:THREE.Raycaster;
		private planePrevIntersection:THREE.Vector3;
		private planeLatestIntersection:THREE.Vector3;
		private planeDefaultY:number;
		private isTouchingToPlane:boolean;

		private isTouching1:boolean;
		private touch1StartScreenPosition:THREE.Vector2;
		private touch1PrevScreenPosition:THREE.Vector2;
		private touch1LatestScreenPosition:THREE.Vector2;
		private touch1NormalizedScreenPosition:THREE.Vector2;

		private isTouching2:boolean;
		private touch2StartScreenPosition:THREE.Vector2;
		private touch2PrevScreenPosition:THREE.Vector2;
		private touch2LatestScreenPosition:THREE.Vector2;
		private touch2NormalizedScreenPosition:THREE.Vector2;

		private touch2StartAngle:number;
		private touch2PrevAngle:number;
		private touch2LatestAngle:number;
		private touch2AverageAngle:SimpleMovingAverage;

		private touch2StartDistance:number;
		private touch2PrevDistance:number;
		private touch2LatestDistance:number;
		private touch2AverageDistance:SimpleMovingAverage;

		private isMouseDown:boolean;
		private isMouseDragging:boolean;
		private mouseDownX:number;
		private mouseDownY:number;
		private mouseUpX:number;
		private mouseUpY:number;
		private mouseUpTime:number;
		private dragStartX:number;
		private dragStartY:number;
		private isWaitingSecondMouseDown:boolean;
		private isOrbitMode:boolean;
		private isTruckMode:boolean;
		private isShiftKeyDown:boolean;

		private marker:JQuery;
		private markerTween:cmd.Command;
		private isMarkerShown:boolean;
		private markerPosition:THREE.Vector3;

		private isEnding:boolean;
		private sequenceTween:cmd.Command;
	}
}
